<template>
  <div id="project">
    <div class="">
      <ol class="breadcrumb">
        <li>
          <a href="#/dashboard">Dashboard</a>
        </li>

        <li>
          <a href="#/myprojects">My Projects</a>
        </li>
        <li class="active">{{ project.name }}</li>
      </ol>
    </div>
    <div class="content login middle" v-loading="loading">
      <div class="cell">
        <div class="container">
          <div class="row">
            <div class="col-xs-12 col-sm-8 col-sm-offset-2 mt20 text-center" v-if="projectHasProducts">
              <button type="button" class="ebutton" style="width: 200px" @click="create_quotation()">
                Create Quotation
              </button>
              <button type="button" class="ebutton ml40" style="width: 200px" :disabled="!canEdit"
                @click="confirm_order()">
                Confirm Order
              </button>
              <button type="button" class="ebutton ml40" style="width: 200px" v-if="userType == 'admin'"
                :disabled="!canProductionOrder" @click="assembly_order()">
                Production Order
              </button>
              <hr />
              <el-skeleton :loading="statusMessageLoading" :rows="1" animated>
                <template slot="template">
                  <el-skeleton-item variant="p" style="height: 25px" />
                </template>
                <template>
                  <p>{{ statusMessages[soStatus] }}</p>
                </template>
              </el-skeleton>
            </div>
            <div class="col-xs-12 col-sm-8 col-sm-offset-2 mb20">
              <p class="sub-title text-center">{{ project.name }}</p>
              <p class="text-center font18 mt30">
                <span>{{ project.city }}, {{ project.country }}</span>
                <span v-if="project.category == 1" class="ml40">Residential</span>
                <span v-if="project.category == 2" class="ml40">Hospitality</span>
                <span v-if="project.category == 3" class="ml40">Marine</span>
                <span v-if="project.category == 4" class="ml40">Commercial</span>
              </p>
              <div class="mt30 text-justify">{{ project.description }}</div>
              <div v-if="userType == 'admin' || userType == 'salesmanager'">


                <el-tooltip :content="((lockProject) ? 'Unlock' : 'Lock') + ' Project For Editing'" placement="top">
                  <el-switch v-model="lockProject" active-color="#ff4949" inactive-color="#13ce66" :active-value="true"
                    :inactive-value="false">
                  </el-switch>
                </el-tooltip>

              </div>
              <div class="mt30" v-if="projectHasProducts">

                <el-tooltip v-if="userType == 'admin'" class="item" effect="dark" content="Duplicate" placement="top">
                  <a class="black mr20" @click="copy_project()">
                    <span class="iconfont3 icon-copy font18"></span>
                  </a>
                </el-tooltip>

                <el-tooltip class="item" effect="dark" content="Download PDF" placement="top"
                  v-if="$store.getters.canDownloadFile('PDF') && !projectHasOnlyAccessories">
                  <a class="black pull-right" @click="download(project._id, project.name)">
                    <span class="iconfont3 icon-pdf_icon font40" style="margin-right: 5px"></span>
                  </a>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="Download CSV" placement="top"
                  v-if="$store.getters.canDownloadFile('CSV')">
                  <a class="black mr20 pull-right" @click="downloadCsv(project._id, project.name)">
                    <span class="iconfont3 icon-csv_icon font40" style="margin-right: 5px"></span>
                  </a>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="Download DXF" placement="top"
                  v-if="$store.getters.canDownloadFile('DXF') && !projectHasOnlyAccessories">
                  <a class="black mr20 pull-right" @click="startDownloadDXF(project._id, project.name)">
                    <span class="iconfont3 icon-dxf_icon font40" style="margin-right: 5px"></span>
                  </a>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="Configuration" placement="top"
                  v-if="$store.getters.canDownloadFile('JSON')">
                  <a class="black mr20 pull-right" @click="downloadJSON(project._id, project.name)">
                    <span class="iconfont3 icon-json_icon font40" style="margin-right: 5px"></span>
                  </a>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="Download XLS" placement="top"
                  v-if="$store.getters.canDownloadFile('XLS')">
                  <a class="black mr20 pull-right" @click="downloadXLS(project._id, project.name)">
                    <span class="iconfont3 icon-xls_icon font40" style="margin-right: 5px"></span>
                  </a>
                </el-tooltip>
              </div>
            </div>
            <div class="col-xs-12 col-sm-8 col-sm-offset-2" style="height:20px">
              <el-progress v-if="progressLoading" color="#337ab7" type="line" :percentage="progressBar"></el-progress>
            </div>
            <div class="col-xs-12 col-sm-8 col-sm-offset-2 mt20" style="margin-bottom: 100px">
              <div class="row">
                <div class="col-sm-3 font16 lh1">
                  <span class="iconfont2 icon-g7 font36 text-middle"></span>
                  <span class="text-middle">ADD A ROOM</span>
                </div>
                <div class="col-sm-4" style="padding-right: 5px">
                  <el-input placeholder="Room 1" v-model="roomtype.name" :disabled="!canEdit"></el-input>
                </div>
                <div class="col-sm-2" style="padding-left: 5px">
                  <el-input placeholder="No. of rooms" v-model="roomtype.rooms_no" :disabled="!canEdit"></el-input>
                </div>
                <div class="col-sm-3 text-center">
                  <button type="button" class="ebutton" @click="create_roomtype()" :disabled="!canEdit">
                    Confirm
                  </button>
                </div>
                <div class="col-sm-12 font12 mt10">
                  Possible names: Suite, Standard Room, Deluxe Room
                </div>

                <div class="col-sm-12 mt20">
                  <el-input suffix-icon="el-icon-search" placeholder="FIND A ROOM" v-model="room_query"></el-input>
                </div>

                <div class="col-sm-12 mt10">
                  <table class="table mb0 table-hover">
                    <tr>
                      <th class>Name</th>
                      <th class="text-center w40"></th>
                      <th>Rooms in the project</th>
                      <th class="text-right w20">Latest change</th>
                    </tr>
                    <!-- loop start -->
                    <tbody>
                      <tr v-for="(i, index) in filtered_roomtypeList" :key="index">
                        <td class>{{ i.name }}</td>
                        <td class="text-center option h40">
                          <router-link :to="'/roomtype/' + i._id" class="black mr20">Open</router-link>
                          <el-tooltip class="item" effect="dark" content="Edit" placement="top" v-if="canEdit">
                            <a class="black mr20" data-toggle="modal" data-target="#editPossible"
                              @click="sendData(index)">
                              <span class="iconfont3 icon-edit font18"></span>
                            </a>
                          </el-tooltip>
                          <el-tooltip class="item" effect="dark" content="Duplicate" placement="top" v-if="canEdit">
                            <a class="black mr20" @click="copy_roomtype(index)">
                              <span class="iconfont3 icon-copy font18"></span>
                            </a>
                          </el-tooltip>
                          <el-tooltip class="item" effect="dark" content="Delete" placement="top" v-if="canEdit">
                            <a class="black" @click="delete_roomtype(i)">
                              <span class="iconfont3 icon-delete font18"></span>
                            </a>
                          </el-tooltip>
                        </td>
                        <td>{{ i.rooms_no }}</td>
                        <td class="text-right">
                          {{
                            new Date(i.modified_at) | dateFormat("DD.MM.YYYY")
                          }}
                        </td>
                      </tr>
                    </tbody>

                    <!-- loop end -->
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal" id="editPossible" tabindex="-1" role="dialog" aria-labelledby data-backdrop="static">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <i class="el-icon-close"></i>
          </button>
          <div class="modal-body">
            <p class="font18 text-center">Edit Room Type</p>
            <div class="row">
              <div class="col-sm-8 col-sm-offset-2">
                <table class="table mt30 font12">
                  <tr>
                    <td>Room Type Name</td>
                    <td>
                      <input type="text" class="form-control" v-model="roomtypePossible.name" />
                    </td>
                  </tr>
                  <tr>
                    <td>Number of rooms</td>
                    <td>
                      <input type="text" class="form-control" v-model="roomtypePossible.rooms_no" />
                    </td>
                  </tr>
                </table>

                <div class="mt50 text-center mb10">
                  <button type="button" data-dismiss="modal" aria-label="Close" class="el-button">
                    Cancel
                  </button>
                  <button type="button" class="el-button el-button--primary" data-dismiss="modal" aria-label="Close"
                    @click="edit_Possible()">
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <project-form @project-updated="getData" ref="projectForm" />
  </div>
</template>

<script>
import axios from "axios";
import ProjectForm from "../components/ProjectForm.vue";

export default {
  name: "project",
  components: {
    ProjectForm,
  },
  data() {
    return {
      DownloaderBroadCast: new BroadcastChannel(this.$store.getters.downloaderBroadcastChannel()),
      progressBar: 0,
      progressLoading: false,
      room_query: "",
      project: {},
      roomtypeList: [],
      roomtype: {
        name: "",
        rooms_no: "",
      },
      lockProject: false,
      current: {},
      roomtypePossible: {},
      loading: false,
      soStatus: "",
      statusMessageLoading: false,
      statusMessages: {
        Open: "Thank you for your pre-order, our sales team is processing your request and will keep you updated on the progress.",
        Processed:
          "Your pre-order has been processed, please check your e-mail Inbox for further actions.",
        "Pending Prepayment":
          "We are waiting for your payment to release the order.",
        Released: "Thank you! You can now place your production order.",
        ReleasedAndPOPlaced: "Your order is in our production queue.",
        DownloaderBroadCast: new BroadcastChannel(this.$store.getters.downloaderBroadcastChannel())
      },
      ignoreWatchOnLockProject: false
    };
  },
  mounted() {
    this.getData();
    this.getRoomtypes();
  },
  computed: {
    projectHasProducts() {
      return this.roomtypeList.filter((r) => r.productCount + r.accessoryCount > 0).length > 0;
    },
    projectHasOnlyAccessories() {
      return this.roomtypeList.filter((r) => r.productCount == 0).length == this.roomtypeList.length;
    },
    filtered_roomtypeList: function () {
      return this.roomtypeList.filter((room) => {
        if (typeof room.name != "undefined" && room.name != "") {
          return room.name
            .toLowerCase()
            .includes(this.room_query.toLowerCase());
        }
      });
    },
    canEdit() {
      if (
        this.lockProject || (
          typeof this.project.erp_document_no != "undefined" &&
          this.project.erp_document_no != null &&
          this.project.erp_document_no != "")
      ) {
        return false;
      }
      return true;
    },
    canProductionOrder() {
      if (this.lockProject) {
        return false;
      } else if (
        typeof this.project.erp_document_no != "undefined" &&
        this.project.erp_document_no != null &&
        this.project.erp_document_no != ""
      ) {
        if (
          typeof this.project.erp_ao != "undefined" &&
          this.project.erp_ao.length > 0
        ) {
          // if (this.userType == 'admin') {
          //   return true;
          // }
          return false;
        }
        return true;
      }
      return false;
    },
    userType() {
      if (this.$store.state.user != null) {
        return this.$store.state.user.type;
      }
      return '';
    },
    userName() {
      return (
        this.$store.state.user.first_name +
        " " +
        this.$store.state.user.last_name
      );
    },
  },
  watch: {
    lockProject: function (value) {
      if (this.ignoreWatchOnLockProject) return;
      var q = (value) ? "lock" : "unlock";
      axios
        .get("/project/" + this.project._id + "/" + q)
        .then((res) => {
          if (res.data.modifiedCount == 1) {
            this.$message({
              type: "success",
              message: "Project " + q + "ed for editing!",
            });
            this.getRoomtypes();
          } else {
            this.$message({
              type: "error",
              message: "Save Failed!",
            });
          }
        })
        .catch(function (error) {
          alert(error);
        });

    },
    "roomtypePossible.rooms_no": function (value) {
      if (isNaN(value) || value < 1) {
        this.roomtypePossible.rooms_no = 1;
      }
    },
    "roomtype.rooms_no": function (value) {
      if (isNaN(value) || value < 1) {
        this.roomtype.rooms_no = 1;
      }
    },
  },
  methods: {
    setLockProjectSilently(value) {
      this.ignoreWatchOnLockProject = true;
      this.lockProject = value;
      this.$nextTick(() => {
        this.ignoreWatchOnLockProject = false;
      });
    },
    async create_quotation() {
      this.loading = true;
      try {
        var response = await axios(
          "/project/" + this.project._id + "/generate_quote")
      } catch (err) {
        if (typeof err.response.data.error != "undefined") {
          this.$message({
            type: "error",
            message: err.response.data.error,
          });
        } else if (err.response.data.order_on_maintenance) {
          this.order_on_maintenance_message();
        }
        this.loading = false;
        return;
      }
      window.console.log(response);
      this.loading = false;
      this.DownloaderBroadCast.postMessage({ type: "initiateDownload", id: `zip_${this.project._id}`, fileType: "zip", fileName: "BN_" + this.project.name + "_Quotation.zip", data: response.data });
    },
    savantActivation() {
      const h = this.$createElement;
      this.$msgbox({
        title: "SAVANT ACTIVATION",
        message: h("p", null, [
          h(
            "span",
            null,
            "Dear " + this.userName + ", please activate your account from the "
          ),
          h(
            "a",
            {
              domProps: {
                href: "https://beta-community.savant.com/marketing/specialty-sales-black-nova",
              },
            },
            "Black Nova specialty page"
          ),
          h(
            "span",
            null,
            " in Savant Dealer Community before confirm the order. "
          ),
        ]),
        showCancelButton: false,
      }).catch(() => { });
    },
    confirm_order_message() {
      const h = this.$createElement;
      this.$msgbox({
        title: "CONFIRM YOUR ORDER",
        message: h("p", null, [
          h(
            "span",
            null,
            "Dear " +
            this.userName +
            ", you are about to place your order to Black Nova."
          ),
          h("br", null, " "),
          h(
            "span",
            null,
            "The project will be closed, and no further modifications in terms of quantity and design can be made."
          ),
          h(
            "span",
            null,
            "Please read the limited warrenty document at this link."
          ),
          h("br", null, " "),
          h(
            "a",
            { domProps: { href: "https://blacknova.co/legal", target: "_blank" } },
            "https:// blacknova.co/legal"
          ),
          h("br", null, " "),
          h("br", null, " "),
          h("input", {
            domProps: {
              type: "checkbox",
              id: "confirm_order",
              style: "margin-right:10px",
            },
          }),
          h("label", null, "I confirm to proceed with the order"),
        ]),
        showCancelButton: true,
        confirmButtonText: "I Agree",
        cancelButtonText: "Cancel",
      })
        .then(async () => {
          if (document.getElementById("confirm_order").checked == true) {
            this.loading = true;
            var error = "";
            var order_on_maintenance = false;
            await axios(
              "/project/" +
              this.project._id +
              "/confirm_order/" +
              this.$store.state.user._id
            ).catch((err) => {
              if (typeof err.response.data.error != "undefined") {
                error = err.response.data.error;
              } else if (err.response.data.order_on_maintenance) {
                this.order_on_maintenance_message();
                order_on_maintenance = true;
              } else {
                error =
                  "Dear customer, <br> your order cannot be process at this moment.<br>We already received a notification and we will get back to you in the next 4 hours.<br> Thank you for you patience.";
              }
            });
            this.loading = false;

            if (order_on_maintenance) {
              return;
            }
            if (error != "") {
              if (error == "Savant ID empty") {
                this.savantActivation();
              } else {
                this.$message({
                  type: "error",
                  dangerouslyUseHTMLString: true,
                  duration: 0,
                  center: true,
                  message: error,
                  showClose: true
                });
              }
              document.getElementById("confirm_order").checked = false;
              return;
            }
            await this.getData();
            this.$message({
              type: "success",
              message:
                "Thank you " +
                this.userName +
                ", your Pre-Order has been successfully generated!",
            });
          } else {
            this.$message({
              type: "warning",
              message:
                "Please check the confirmation checkbox before proceeding.",
            });
          }
          document.getElementById("confirm_order").checked = false;
        })
        .catch(() => {
          document.getElementById("confirm_order").checked = false;
        });
    },
    confirm_order_system_check() {
      const h = this.$createElement;
      this.$msgbox({
        title: "SYSTEM TYPE UNSPECIFIED",
        message: h("p", null, [
           h(
            "span",
            null,
            "Dear " +
              this.userName +
              ","
          ),
          h("br", null, " "),
          h(
            "span",
            null,
            "The system type is unspecified, kindly edit the project information accordingly."
          ),
        ]),
        showCancelButton: true,
        confirmButtonText: "Edit Project",
        cancelButtonText: "Cancel",
      })
        .then(() => {
          this.$refs.projectForm.showModal(this.project);
        })
        .catch(() => { });
    },
    order_on_maintenance_message() {
      const h = this.$createElement;
      this.$msgbox({
        title: "Portal Maintenance Notification",
        message: h("p", null, [
          h(
            "span",
            null,
            "Dear " +
              this.userName +
              ","
          ),
          h("br", null, " "),
          h(
            "span",
            null,
            "Please be informed that our Portal is currently undergoing scheduled maintenance."
          ),
          h("br", null, " "),
          h(
            "span",
            null,
            "During this time, some functions will be temporarily unavailable. We apologize for any inconvenience this may cause and appreciate your understanding."
          ),
          h("br", null, " "),
          h(
            "span",
            null,
            "Should you require immediate assistance or have any urgent requests, please feel free to contact us directly at sales@blacknova.co."
          ),
        ]),
      })
        .then(() => {
        })
        .catch(() => {});
    },
    async confirm_order() {
      if (!this.canEdit || !(await this.canConfirm("order"))) {
        return;
      }

      if (!this.project.system) {
        this.confirm_order_system_check();
      } else {
        this.confirm_order_message();
      }
    },
    async assembly_order() {
      if (!this.canProductionOrder || !(await this.canConfirm("assy-order"))) {
        return;
      }

      if (!(await this.checkSalesOrderStatus(this.project.erp_document_no))) {
        return;
      } 

      const h = this.$createElement;
      this.$msgbox({
        title: "CONFIRM YOUR PRODUCTION ORDER",
        message: h("p", null, [
          h(
            "span",
            null,
            "Dear " +
            this.userName +
            ", you are about to place your production order to Black Nova."
          ),
          h("br", null, " "),
          h(
            "span",
            null,
            "Please read the limited warrenty document at this link."
          ),
          h("br", null, " "),
          h(
            "a",
            { domProps: { href: "https:// blacknova.co/legal" } },
            "https:// blacknova.co/legal"
          ),
          h("br", null, " "),
          h("br", null, " "),
          h("input", {
            domProps: {
              type: "checkbox",
              id: "confirm_production_order",
              style: "margin-right:10px",
            },
          }),
          h("label", null, "I confirm to proceed with the production order"),
        ]),
        showCancelButton: true,
        confirmButtonText: "I Agree",
        cancelButtonText: "Cancel",
      })
        .then(async () => {
          if (
            document.getElementById("confirm_production_order").checked == true
          ) {
            this.loading = true;
            try {
              await axios(
                "/project/" +
                this.project._id +
                "/confirm_production_order/" +
                this.$store.state.user._id
              );
              this.loading = false;
              await this.getData();
              this.$message({
                type: "success",
                message:
                  "Thank you " +
                  this.userName +
                  ", your production request has been successfully queued! You will be contacted by the Sales Team for shipment operations when ready!",
              });
            } catch (err) {
              this.loading = false;
              if (err.response.data.order_on_maintenance) {
                this.order_on_maintenance_message();
                return;
              }
              this.$message({
                type: "error",
                message:
                  "Attention! Your production requests has been not queued, please try again later. Thank you.",
              });
            }
          } else {
            this.$message({
              type: "warning",
              message:
                "Please check the confirmation checkbox before proceeding.",
            });
          }
          document.getElementById("confirm_production_order").checked = false;
        })
        .catch(() => {
          document.getElementById("confirm_production_order").checked = false;
        });
    },
    async download(id, name) {
      this.DownloaderBroadCast.postMessage({ type: "initiateDownload", id: `pdf_${id}`, fileType: "pdf", fileName: "BN_" + name + "_Artwork.pdf", data: { projectId: id } });
    },
    async downloadCsv(id, name) {
      this.DownloaderBroadCast.postMessage({ type: "initiateDownload", id: `csv_${id}`, fileType: "csv", fileName: "BN_" + name + "_Artwork.csv", data: { projectId: id } });
    },
    async checkArtworksForSpecShars(project_id) {
      try {
        var response = await axios(
          "/project/" + project_id + "/check-artworks-for-spec-chars"
        );
        return response.data;
      } catch (err) {
        window.console.log(err);
      }
    },
    async startDownloadDXF(project_id, project_name) {
      var check = await this.checkArtworksForSpecShars(project_id);
      const h = this.$createElement;
      if (check.error) {
        var productsElem = [];

        for (var product of check.error.products) {
          productsElem.push(
            h("li", null, [
              h(
                "a",
                {
                  domProps: {
                    target: "_blank",
                    href: "#/collection/engraving/p" + product._id,
                  },
                },
                product._id + " | " + product.product_name
              ),
            ])
          );
        }

        this.$msgbox({
          title: "ATTENTION",
          message: h("div", null, [
            h("span", null, check.error.message),
            h("br", null, " "),
            h("br", null, " "),
            h("ul", { style: "list-style-type: none" }, [productsElem]),
          ]),
          showCancelButton: true,
          confirmButtonText: "Proceed wih download",
          cancelButtonText: "Cancel",
        })
          .then(() => {
            this.downloadDXF(project_id, project_name);
          })
      } else {
        this.downloadDXF(project_id, project_name);
      }
    },
    async downloadDXF(project_id, project_name) {
      this.DownloaderBroadCast.postMessage({ type: "initiateDownload", id: `dxf_${project_id}`, fileType: "dxf", fileName: "BN_" + project_name + "_Project.zip", data: { projectId: project_id } });
    },
    async downloadJSON(id, name) {
      this.DownloaderBroadCast.postMessage({ type: "initiateDownload", id: `json_${id}`, fileType: "json", fileName: "BN_" + name + "_Configuration.json", data: { projectId: id } });
    },
    async downloadXLS(id, name) {
      this.DownloaderBroadCast.postMessage({ type: "initiateDownload", id: `xls_${id}`, fileType: "xls", fileName: "BN_" + name + "_Project.xls", data: { projectId: id } });
    },
    async getSOStatus() {
      if (typeof this.project.erp_document_no == 'undefined' || this.project.erp_document_no == '') {
        return;
      }
      this.statusMessageLoading = true;
      var responseStatus = await axios.get(
        "/project/check-sales-order-status/" + this.project.erp_document_no
      );
      if (
        responseStatus.data.status == "Released" &&
        typeof this.project.erp_ao != "undefined" &&
        this.project.erp_ao.length > 0
      ) {
        this.soStatus = "ReleasedAndPOPlaced";
      } else {
        this.soStatus = responseStatus.data.status;
      }
      this.statusMessageLoading = false;
    },
    async getData() {
      this.loading = true;
      var response = await axios.get(
        "/project/single/" + this.$route.params.id
      );
      this.project = response.data[0];
      if (typeof this.project.lockProject != "undefined") {
        this.setLockProjectSilently(this.project.lockProject);
      }
      this.current = Object.assign({}, this.project);
      this.loading = false;
      this.getSOStatus();
    },
    async getRoomtypes() {
      this.loading = true;
      axios.get("/roomtype/" + this.$route.params.id).then((response) => {
        this.roomtypeList = response.data;
        this.loading = false;
      });
    },
    sendData(index) {
      this.roomtypePossible = Object.assign({}, this.roomtypeList[index]);
    },
    edit_Possible() {
      if (!this.canEdit) {
        return;
      }
      axios
        .put("/roomtype/" + this.roomtypePossible._id, {
          roomtype: this.roomtypePossible,
        })
        .then((res) => {
          if (res.data.ok == 1) {
            this.$message({
              type: "success",
              message: "Save!",
            });
            this.getRoomtypes();
          } else {
            this.$message({
              type: "error",
              message: "Save Failed!",
            });
            window.console.log(res);
          }
        })
        .catch(function (error) {
          alert(error);
        });
    },
    delete_roomtype(rt) {
      if (!this.canEdit) {
        return;
      }
      const h = this.$createElement;
      this.$msgbox({
        title: "DELETE ROOM TYPE",
        message: h("p", null, [
          h("span", null, "Are you sure you want to delete?"),
          h("br", null, " "),
          h("span", { style: "color: red" }, rt.name + "?"),
        ]),
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      })
        .then(() => {
          axios
            .delete("/roomtype/" + rt._id)
            .then((res) => {
              if (res.data.ok == 1) {
                this.$message({
                  type: "success",
                  message: "Deleted!",
                });
                this.getRoomtypes();
              } else {
                this.$message({
                  type: "error",
                  message: "Delete Failed!",
                });
                window.console.log(res);
              }
            })
            .catch(function (error) {
              window.console.log(error);
            });
        })
        .catch(() => { });
    },
    create_roomtype() {
      if (!this.canEdit) {
        return;
      }
      this.roomtype.pid = this.$route.params.id;
      if (this.roomtype.name == "" || this.roomtype.rooms_no == "") {
        this.$message({
          type: "error",
          message: "Please enter name and no of rooms!",
        });
        return;
      }
      axios
        .post("/roomtype/", {
          roomtype: this.roomtype,
        })
        .then((res) => {
          if (res.data.ok == 1) {
            this.$message({
              type: "success",
              message: "Created!",
            });
            this.getRoomtypes();
          } else {
            this.$message({
              type: "error",
              message: "Create Failed!",
            });
            window.console.log(res);
          }
        })
        .catch(function (error) {
          window.console.log(error);
        });
    },
    changePIdsOnRooms(rooms, pid) {
      return rooms.map((room) => {
        room.pid = pid;
        return room;
      });
    },
    async copy_project() {
      if (this.userType != 'admin') {
        return;
      }
      this.loading = true;
      var project = Object.assign(
        {},
        this.project
      );
      delete project._id;
      delete project.erp_document_no;
      delete project.erp_ao
      project.uid = this.$store.state.user._id

      axios
        .post("/project/", {
          project: project,
        })
        .then(async (res) => {
          if (res.data.ok == 1) {
            var rooms = this.changePIdsOnRooms(this.roomtypeList, res.data.insertedId);
            for (var room of rooms) {
              await axios.post("/roomtype/duplicate", { roomtype: room });
            }
            this.$message({
              type: "success",
              message: "Copied!",
            });
            this.loading = false;
            this.getData();
          } else {
            this.$message({
              type: "error",
              message: "Copy Failed!",
            });
            this.loading = false;
          }
        })
        .catch(function (error) {
          alert(error);
          this.loading = false;
        });
    },
    copy_roomtype(item) {
      if (!this.canEdit) {
        return;
      }
      this.loading = true;
      axios
        .post("/roomtype/duplicate", {
          roomtype: this.roomtypeList[item],
        })
        .then((res) => {
          if (res.data.ok == 1) {
            this.$message({
              type: "success",
              message: "Copied!",
            });
            this.loading = false;
            this.getRoomtypes();
          } else {
            this.$message({
              type: "error",
              message: "Copy Failed!",
            });
            this.loading = false;
            window.console.log(res);
          }
        })
        .catch(function (error) {
          window.console.log(error);
          this.loading = false;
        });
    },
    async canConfirm(type) {
      const response = await axios.get(
        "/project/can-confirm/" + type + "/" + this.$store.state.user._id
      );
      if (typeof response.data.error != "undefined") {
        this.$message({
          type: "error",
          message: response.data.error,
        });
        return false;
      }
      return true;
    },
    async checkSalesOrderStatus(salesOrderNo) {
      if (salesOrderNo == 'undefined' || salesOrderNo == '') {
        return;
      }
      const response = await axios.get(
        "/project/check-sales-order-status/" + salesOrderNo
      );
      if (
        typeof response.data.error != "undefined" &&
        response.data.error != ""
      ) {
        this.$message({
          type: "error",
          message: response.data.error,
        });
        return false;
      }
      return true;
    },
  },
};
</script>
